import axios from "axios";
import store from "@/store/index";
import cleanParams from "./cleanParams";

const URL = window.location;
const CSRF_META = document.querySelector('meta[name="csrf-token"]');

const axiosApi = axios.create({
	baseURL: `${URL.protocol}//${URL.hostname}/api/`,
});

axiosApi.interceptors.request.use(
	async (config) => {
		const token = localStorage.getItem("auth_token");

		const data = {
			...config,
			headers: {
				...config.headers,
				Authorization:
					config.headers.Authorization || `Bearer ${token}`,
				"X-CSRF-TOKEN": CSRF_META?.getAttribute("content"),
			},
			params: cleanParams(config.params),
		};
		// console.debug("[request]", data);
		return data;
	},
	(error) => {
		console.warn("error");
		Promise.reject(error);
	}
);

axiosApi.interceptors.response.use(
	function (response) {
		return response;
	},
	function (error) {
		if (error.response.status !== 200) {
			const responseMessage = error?.response?.data?.message;
			const responseError = error?.response?.data?.error;

			/**
			 * Reset b-alert message
			 * Bug Fix - CRA-915
			 */
			// store.commit("alert/error", "");
			/* end */

			if (responseMessage) {
				store.commit("alert/error", responseMessage);
			} else if (responseError) {
				store.commit("alert/error", responseError);
			} else {
				console.warn(error);
			}
		}
		return Promise.reject(error);
	}
);

export default axiosApi;
